













import Vue, {PropType} from "vue";
import { MagentoProduct } from "@/lib/MagentoTypes";
import { resizedPath } from "@/lib/images";

export default Vue.extend({
  props: {
    product: {
      type: Object as PropType<MagentoProduct>,
      required: true,
    },
    itemcounter: {
      type: Number,
      default: 0
    },
  },
  computed:{
    subline(): string | undefined {
      return this.product.custom_attributes?.subline as (string | undefined);
    },
    imagePath():string {
      const hasGalleryEntries = Array.isArray(this.product?.media_gallery_entries) && this.product?.media_gallery_entries.length;
      return hasGalleryEntries ? "https://vygon-api.cekom.de" + resizedPath('/media/catalog/product' + this.product.media_gallery_entries[0].file, 430, 430) : ''
      // if(typeof this.product.media_gallery_entries != "undefined"){ //Hotfix
      //   return "https://vygon-api.cekom.de" + resizedPath('/media/catalog/product' + this.product.media_gallery_entries[0].file, 430, 430);
      // }else{
      //   return "";
      // }
    }
  }
});
